import { px } from "@contember/utilities";
import { useCallback, useLayoutEffect } from "react";
import { unwrapRefValue } from "./unwrapRefValue.js";
import { useOnElementResize } from "./useOnElementResize.js";
const useAutoHeightTextArea = (textAreaRef, value, minRows, maxRows) => {
  const measure = useCallback(async (ref, minRows2, maxRows2) => {
    if (ref) {
      const rowsAttribute = ref.rows;
      ref.style.height = "";
      ref.style.minHeight = "";
      ref.style.maxHeight = "";
      if (minRows2 !== maxRows2) {
        const height = ref.scrollHeight;
        let minHeight;
        let maxHeight;
        ref.rows = minRows2;
        minHeight = await ref.getBoundingClientRect().height;
        if (maxRows2 === Infinity) {
          maxHeight = Infinity;
        } else {
          ref.rows = maxRows2;
          maxHeight = await ref.getBoundingClientRect().height;
        }
        ref.style.height = px(height);
        ref.style.minHeight = px(minHeight);
        ref.style.maxHeight = px(maxHeight);
      }
      ref.rows = rowsAttribute;
    }
  }, []);
  useOnElementResize(textAreaRef, () => {
    measure(unwrapRefValue(textAreaRef), minRows, maxRows);
  });
  useLayoutEffect(() => {
    measure(unwrapRefValue(textAreaRef), minRows, maxRows);
  }, [maxRows, measure, minRows, textAreaRef, value]);
};
export {
  useAutoHeightTextArea
};
//# sourceMappingURL=useAutoHeightTextArea.js.map
